<!-- Template -->
<template>
  <div class="gateway-targets">
    <!-- List Section -->
    <b-table v-if="data.length && !addTargetServer"
      id="target-server-table"
      striped
      hover
      :items="data"
      :sort-desc="true"
      :fields="targetServerTableFields"
      class="table table-hover m-0 align-middle"
      medium>
      <template #cell(host)="data"  #row-details="row">
        <span v-bind:id="data.item.id + '-host'">
          {{data.value}}
        </span>
        <!-- WIP. For now no editing. WIP. -->
        <!-- <a @click="data.item.editing = !data.item.editing;"  v-b-tooltip.click.html="generateTipData(data.item.id + '-host', 'input')">
          <img v-if="data.item.editing" class="gateway__tool-button ml-1" 
          src='../../assets/images/saveIcon.svg' />
          <img v-if="!data.item.editing" class="gateway__tool-button ml-1" 
          src='../../assets/images/edit.svg' />
        </a> -->
      </template>
      <template #cell(isEnabled)="data"  #row-details="row">
        <span v-bind:id="data.item.id + '-isEnabled'">
          {{data.value}}
        </span>
        <!-- WIP. For now no editing. WIP. -->
        <!-- <a @click="data.item.editing = !data.item.editing;"  v-b-tooltip.click.html="generateTipData(data.item.id + '-isEnabled', 'select', ['true', 'false'])">
          <img v-if="data.item.editing" class="gateway__tool-button ml-1" 
          src='../../assets/images/saveIcon.svg' />
          <img v-if="!data.item.editing" class="gateway__tool-button ml-1" 
          src='../../assets/images/edit.svg' />
        </a> -->
      </template>
      <template #cell(sslEnabled)="data"  #row-details="row">
        <span v-bind:id="data.item.id + '-sslEnabled'">
          {{data.value}}
        </span>
        <!-- WIP. For now no editing. WIP. -->
        <!-- <a @click="data.item.editing = !data.item.editing;"  v-b-tooltip.click.html="generateTipData(data.item.id + '-sslEnabled', 'select', ['true', 'false'])">
          <img v-if="data.item.editing" class="gateway__tool-button ml-1" 
          src='../../assets/images/saveIcon.svg' />
          <img v-if="!data.item.editing" class="gateway__tool-button ml-1" 
          src='../../assets/images/edit.svg' />
        </a> -->
      </template>
    </b-table>
    
    <!-- Add Target Server -->
    <div v-if="data.length && addTargetServer ">
      <hr style="margin: 0;">
      <p style="margin: 15px; margin-top: 30px;">
        In this form you are adding a hostname to the environment for the CareAI gateway. Upon success, you can add and / or edit routes to utilize this new backend host.
      </p>
      <form style="padding: 15px;">
        <div class="form-group">
          <label for="target_server_name">Target server name</label>
          <input v-model="target_server_name" v-on:change="validateTargetNameField(target_server_name)" 
            onkeyup="this.value = this.value.toUpperCase();" 
            onkeydown="this.value = this.value.toUpperCase();" 
            onfocusout="this.value = this.value.toUpperCase();" 
            type="text" class="form-control" id="target_server_name" aria-describedby="targetServer" placeholder="Target server name">
          <small id="targetServer" v-bind:class="{ 'gateway__target_form--invalid': !target_server_name_message.valid }" class="form-text text-muted">{{ target_server_name_message.message }}</small>
        </div>
        <div class="form-group">
          <label for="host_name">Hostname</label>
          <input v-model="host_name" v-on:change="validateTargetHostField(host_name)" type="text" class="form-control" id="host_name" aria-describedby="hostName" placeholder="Host name">
          <small id="hostName" v-bind:class="{ 'gateway__target_form--invalid': !host_name_message.valid }" class="form-text text-muted">{{ host_name_message.message }}</small>
        </div>
        <button :disabled="!target_server_name_message.valid || !host_name_message.valid" type="submit" @click.prevent="submitTargetServer(target_server_name, host_name)" class="btn btn-primary gateway__tool-button">Submit</button>
      </form>
    </div>

    <div v-if="!data">
      <div v-if="loading" class="gateway__select-environment-message">
        <div class="d-flex justify-content-center align-items-center container" style="height: 500px;">
          <div class="loader"></div>
        </div>
      </div>
    </div>
  </div>

</template>
<!-- End Template -->

<!-- Scripts -->
<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Dropdown from "vue-simple-search-dropdown";

Vue.use(VueToast);
Vue.use(Loading);

export default {
  name: "GatewayTargetServers",
  components: { Dropdown },
  data() {
    return {
      // View State & Init
      loading: true,
      viewReady: false,
      
      // Target Server Table Fields
      targetServerTableFields: [
        {
          key: 'id',
          label: 'Target Server Id',
          sortable: true,
        },
        {
          key: 'host',
          label: 'Host',
          sortable: true,
        },
        {
          key: 'isEnabled',
          label: 'Is Enabled',
        },
        {
          key: 'sslEnabled',
          label: 'SSL Enabled',
        },
      ],

      // Form helpers
      target_server_name_message: { valid: true, message: "Enter a unique target server name. Only alphanumeric characters and dashes supported." },
      host_name_message: { valid: true, message: "Enter a unique target server host name." }
      
    };
  },
  props: ["data", "environment", "addTargetServer"],

  created() {
    this.onInit();
  },

  methods: {
    async onInit() {
      if (!this.$auth.isAuthenticated) {
        return;
      }
    },

    async submitTargetServer(name, host) {
      host = host.replace('https://', '');
      host = host.replace('http://', '');
      host = host.replace(/\//g, '');
      this.validateTargetHostField(name); 
      this.validateTargetHostField(host);
      if (this.target_server_name_message.valid && this.host_name_message.valid) {
        
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var request = new Request(
          config.OPERATIONS_SERVICE + `/environments/${this.environment.id}/targetservers`, 
          {
            method: 'POST',
            mode: 'cors',
            cache: 'default',
            withCredentials: true,
            credentials: 'include',
            headers: {
              Authorization: 'Bearer ' + id_token,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              name, host,
            })
          }
        );

        // Attempt to get Gateways
        try {
          const response = await fetch(request);
          if (response.status === 403) {
            Vue.$toast.open({
              message: "Uh oh... You don't have the permission required to access this resource",
              type: 'error',
            });
            return;
          }
          if (response.status == 401) {
            Vue.$toast.open({
              message: 'Your session has expired please login again to continue',
              type: 'error',
            });
            return;
          }
          if (response.status == 503) {
            return this.submitTargetServer(name, host);
          }
          if (response.status != 200) {
            Vue.$toast.open({
              message: 'Unable to get data',
              type: 'error',
            });
            return;
          } else {
            // Post
            const res = await response.json();
            this.$emit('refresh-targets', true);
          }
        } catch (tex) {
          Vue.$toast.open({message: 'Failed to create target due to an error.', type: 'error'});
        }
      }

    },

    validateTargetNameField(name) {
      this.target_server_name_message.message = "Enter a unique target server name. Only alphanumeric characters and dashes supported.";
      if (this.data.find((row) => row.id === name.toUpperCase())) {
        this.target_server_name_message.message = "This target name already exists.";
        this.target_server_name_message.valid = false;
      } else if (!name) {
        this.target_server_name_message.message = "Enter a unique target server name. Only alphanumeric characters and dashes supported.";
        this.target_server_name_message.valid = false;
      } else if (name.search(/^([a-zA-Z0-9-]+)$/) === -1) {
        this.target_server_name_message.message = "Only alphanumerics and dashes.";
        this.target_server_name_message.valid = false;
      }
      else this.target_server_name_message.valid = true;
    },

    validateTargetHostField(host) {
      this.host_name_message.message  = "Enter a unique target server host name.";
      host = host.replace('https://', '');
      host = host.replace('http://', '');
      host = host.replace(/\//g, '');
      if (this.data.find((row) => row.host === host)) {
        this.host_name_message.message = "This host name already exists.";
        this.host_name_message.valid = false;
      } else if (!host.endsWith('.com') && !host.endsWith('.ai') && !host.endsWith('.app')) {
        this.host_name_message.message = "Only supporting hostnames ending .com, .app and .ai";
        this.host_name_message.valid = false;
      } else if (!host) {
        this.host_name_message.message = "Only supporting hostnames ending with .com, .app and .ai";
        this.host_name_message.valid = false;
      }
      else this.host_name_message.valid = true;
    },
  },
  watch: {},
};
</script>
<!-- End Scripts -->

<!-- Styles -->
<style lang="scss" scoped>
.gateway-targets {
  a {
    color: rgb(37, 169, 202);
    display: flex;
    align-items: center;
    margin-top: 15px;
    text-decoration: none;
    transition: color 500ms;

    &:hover {
      color: rgb(24, 194, 236);
    }
  }

  label {
    color: black;
    font-weight: 600;
  }

  .gateway__method-bubble {
    text-decoration: none;
    color: white;
    padding: 5px;
    background-color: #222222;
    border-radius: 2px;
  }

  .gateway__target_form--invalid {
    color: #F27778 !important;
  }
  
  .gateway__get-bubble {
    background-color: #66BE6D;
  }

  .gateway__delete-bubble {
    background-color: #F27778;
  }

  .gateway__patch-bubble {
    background-color: #eaf7ff;
  }

  .gateway__post-bubble {
    background-color: #484848;
  }

  .gateway__put-bubble {
    background-color: #1dd8f6;
  }

  .btn-primary.disabled, .btn-primary:disabled {
    background-color: #484848;
  }
  .loader {
    border: 3px solid #f3f3f3; /* Light grey */
    border-top: 3px solid rgba(37, 168, 202, 0.8); /* Blue */
    border-radius: 50%;
    width: 45px;
    height: 45px;
    animation: spin 1.5s linear infinite;
  }

  .accordion-heading {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .collapse.in {
    overflow: visible;
  }

  .ml-a {
    margin-left: auto;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
<!-- End Styles -->